import { defineComponent } from "vue";
import { mapActions, mapState } from "pinia";

import { useApp } from "../App/useApp";
import config from "../../common/config";
import CentralCalendarRouter from "./CentralCalendarRouter";
import { ApplicationEnum } from "../../enums/enums";

import LevelTwo from "../LevelTwo/LevelTwo.vue";

export default defineComponent({
    components: {
        LevelTwo
    },
    data() {
        return {
            showPatients: false,
            showEmployees: false,
            showBorder: true,
            activeItem: null,
            router: null
        };
    },
    computed: {
        ...mapState(useApp, ["showFrequencyWatch", "showHosNav", "organizations", "showMainHeader"])
    },
    mounted() {
        this.router = CentralCalendarRouter.filter((route: any) => {
            if (!!route.meta.showFrequencyWatch) {
                return this.showFrequencyWatch;
            } else if (!!route.meta?.showIfNotOnlyHH) {
                return this.isShowIfNotOnlyHH();
            } else if (!!route.meta.showHopeReport) {
                return this.showHosNav;
            } else {
                return true;
            }
        });
        (this.$refs.calendarRef as any).addEventListener("scroll", this.onScroll);
    },
    methods: {
        ...mapActions(useApp, ["setHeader"]),
        isShowIfNotOnlyHH() {
            const organizationId = window.localStorage.getItem(config.organizationId);
            const organization = this.organizations.find((org) => org.id === organizationId);
            const isOnlyHH = organization?.agencies.every(
                (agency) => agency.application === ApplicationEnum.AgencyCore
            );
            return isOnlyHH ? false : true;
        },
        onScroll() {
            const calendar = this.$refs.calendarRef as HTMLElement;

            if (calendar.scrollTop === 0 && !this.showMainHeader) {
                this.setHeader(true);
            }

            if (calendar.scrollTop >= 215 && this.showMainHeader) {
                this.setHeader(false);
            }
        }
    }
});
